import React from 'react';
import { Row, Col, Button, Spin } from 'antd';
import './assets/css/package.css';
import dummyImage from './assets/Rectangle 187.png';
import calendarIcon from './assets/calendar 1.png';
import { useHistory, useParams } from 'react-router';
import {
  useGetAllPackagesQuery,
  useGetPackagesDetailsByIdQuery,
  useGetQuoteDetailsByIdQuery,
} from './packageSlice';

import mainlake from './ManagePackage.js/images/exotic_main_lake.png';
import exoticLogo from '../../../assets/images/Logos/exotic-fishing-logo.png';
import paymentBanner from './assets/online-payment-options-banner.png';
import dayjs from 'dayjs';

function QuoteBooking() {
  const fisheryId = useParams()['fishery_id'];
  const ReservationId = useParams()['quote_id'];
  const history = useHistory();
  const { data: packages, isLoading: packageDetailLoading } =
    useGetQuoteDetailsByIdQuery(
      { package_id: ReservationId },
      {
        skip: !fisheryId && !ReservationId,
      }
    );
  const { data: AllPackages, isLoading: packagesLoading } =
    useGetAllPackagesQuery(fisheryId, {
      skip: !fisheryId,
    });

  let Package = packages?.message;
  const paymentIcons = [
    {
      alt: 'Guarantee',
      src: 'https://img.icons8.com/color/48/guarantee.png',
    },
    {
      alt: 'PayPal',
      src: 'https://img.icons8.com/color/48/paypal.png',
    },
    {
      alt: 'Visa',
      src: 'https://img.icons8.com/color/48/visa.png',
    },
    {
      alt: 'MasterCard',
      src: 'https://img.icons8.com/color/48/mastercard.png',
    },
    {
      alt: 'Amex',
      src: 'https://img.icons8.com/color/48/amex.png',
    },
    {
      alt: 'Discover',
      src: 'https://img.icons8.com/color/48/discover.png',
    },
    {
      alt: 'McAfee',
      src: 'https://img.icons8.com/color/48/mcafee.png',
    },
  ];
  const totalRoomsBooked = Package?.accommodation_details.reduce(
    (acc, room) => acc + room.quantity,
    0
  );
  const formatDatesByMonth = (dates) => {
    const suffix = (d) => {
      if (d > 3 && d < 21) return 'th';
      switch (d % 10) {
        case 1:
          return 'st';
        case 2:
          return 'nd';
        case 3:
          return 'rd';
        default:
          return 'th';
      }
    };

    const sortedDates = dates?.map((d) => dayjs(d)).sort((a, b) => a - b);

    const grouped = {};

    sortedDates?.forEach((date) => {
      const month = date.format('MMMM');
      const day = `${date.date()}${suffix(date.date())}`;
      if (!grouped[month]) grouped[month] = [];
      grouped[month].push(day);
    });

    return Object.entries(grouped)
      .map(([month, days]) => `${days.join(', ')} ${month}`)
      .join(' - ');
  };
  return (
    <div>
      <Row className='exotic-header' align='middle'>
        <Col xs={24} sm={24} md={12} className=''>
          <img
            src={exoticLogo}
            alt='Exotic Fishing Thailand'
            className='logo'
          />
        </Col>
        <Col xs={24} sm={24} md={12} className='partner-logo'>
          <div className='justify-end display-flex-column'>
            <div className='fs-10 gBold sb-blue-800'>Powered By:</div>
            <div className='fs-20 gSemiBold lh-1'>
              <span className='sb-blue-500'>swim</span>booker
            </div>
          </div>
        </Col>
      </Row>
      <div className='booking-container'>
        <div style={{ maxWidth: 1400 }} className='mg-auto'>
          <Row style={{ marginTop: 100 }} className='w-full gap-1r'>
            <Col xs={24} sm={24} md={13} lg={16} className='mg-top-30'>
              <div className='quote-image'>
                <img src={mainlake} alt='Exotic Fishing Thailand' />
                <div className='gradient'></div>
                <div className='quote-title'>EXOTIC FISHING THAILAND</div>
              </div>
              <div className='quote-details-container details'>
                <Row className='package-row '>
                  <Col className='package-content'>
                    <h3 className='package-title fs-24'>
                      {Package?.angler_information?.title}{' '}
                      {Package?.angler_information?.first_name}{' '}
                      {Package?.angler_information?.last_name} - PLEASE SEE YOUR
                      EXOTIC FISHING THAILAND QUOTE BELOW
                    </h3>
                    <p className='package-description'>
                      {Package?.description}
                    </p>

                    {/* Features */}
                    <Row gutter={[10, 10]} className='details-package-features'>
                      {Package?.included_benefits
                        ?.filter((b) => b.selected)
                        .map((benefit) => (
                          <Col xs={12} sm={8}>
                            <div className='feature-item'>
                              <img
                                src={calendarIcon}
                                width={14}
                                height={14}
                                alt='benefit'
                                className='mg-right-5'
                              />{' '}
                              {benefit?.customText
                                ? benefit?.customText
                                : benefit?.label}
                            </div>
                          </Col>
                        ))}
                      {Package?.other_benefits?.data
                        ?.filter((b) => b.selected)
                        .map((benefit) => (
                          <Col xs={12} sm={8}>
                            <span className='feature-item'>
                              <img
                                src={calendarIcon}
                                width={14}
                                height={14}
                                alt='benefit'
                                className='mg-right-5'
                              />{' '}
                              {benefit?.name}
                            </span>
                          </Col>
                        ))}
                    </Row>

                    {/* Pricing */}
                    <div className='package-pricing'>
                      <div className='package-details-price-container mg-bottom-10  row-center justify-between'>
                        <span className='package-price-label   font-montserrat sb-blue-700'>
                          YOUR QUOTE
                        </span>
                        <div className='package-price  sb-blue-bg-100 font-montserrat sb-blue-700'>
                          £{Package?.total_price?.toFixed(2)}
                        </div>
                      </div>
                      <div className='package-details-price-container  row-center justify-between'>
                        <span className='package-price-label   font-montserrat sb-blue-700'>
                          PAY TODAY
                        </span>
                        <div className='package-price  sb-blue-bg-100 font-montserrat sb-blue-700'>
                          £{Package?.deposit?.toFixed(2)}
                        </div>
                      </div>
                    </div>

                    {Package?.booking_status == 'expired' && (
                      <div className='fs-24 gBold mg-top-20 txt-center'>
                        This quote has expired
                      </div>
                    )}
                    {Package?.booking_status !== 'expired' && (
                      <Button
                        className='details-book-button'
                        onClick={() => {
                          history.push(
                            `/booking/package/reservation/${fisheryId}/${Package?.id}`
                          );
                        }}
                      >
                        ACCEPT QUOTE & BOOK NOW
                      </Button>
                    )}
                  </Col>
                </Row>
              </div>
              <div
                className='row-center justify-center gap-1r bg-white pd-10 mg-top-20 flex-wrap'
                style={{ borderRadius: 16 }}
              >
                <div className='safe-checkout-label fs-20 sb-blue-700 gBold'>
                  VERIFIED SAFE CHECKOUT
                </div>
                <div className='safe-checkout-divider'></div>
                <div className='safe-checkout-icons flex-wrap'>
                  <img src={paymentBanner} alt='payment' />
                </div>
              </div>
            </Col>
            <Col xs={24} sm={24} md={10} lg={7}>
              <div className='quote-summary w-full'>
                <div className='quote-heading mg-bottom-20'>QUOTE SUMMARY</div>
                <div className='summary-details'>
                  {/* Accommodation */}
                  <Row className='summary-section gSemiBold sb-blue-900 '>
                    <Col
                      span={24}
                      className='row-center justify-between mg-bottom-15 fs-16 '
                    >
                      <div>Accommodation Included:</div>
                      <div>{Package?.has_accommodation ? 'Yes' : 'No'}</div>
                    </Col>

                    <Col className='details' span={12}>
                      No. Of Adults:
                    </Col>
                    <Col span={12} className='summary-value details'>
                      {Package?.accommodation_users?.no_of_adults}
                    </Col>

                    <Col className='details' span={12}>
                      No. Of Children:
                    </Col>
                    <Col span={12} className='summary-value details'>
                      {Package?.accommodation_users?.no_of_children}
                    </Col>

                    <Col className='details' span={12}>
                      No. Of Rooms:
                    </Col>
                    <Col span={12} className='summary-value details'>
                      {totalRoomsBooked}
                    </Col>

                    <Col className='details' span={12}>
                      Arrival Date:
                    </Col>
                    <Col span={12} className='summary-value details'>
                      {dayjs(Package?.check_in_date).isValid() &&
                        dayjs(Package?.check_in_date).format('DD/MM/YYYY')}
                    </Col>

                    <Col className='details' span={12}>
                      Departure Date:
                    </Col>
                    <Col span={12} className='summary-value details'>
                      {dayjs(Package?.check_out_date).isValid() &&
                        dayjs(Package?.check_out_date).format('DD/MM/YYYY')}
                    </Col>
                  </Row>

                  {/* Fishing */}
                  <Row className='summary-section gSemiBold sb-blue-900 '>
                    <Col
                      span={24}
                      className='row-center justify-between mg-bottom-15 fs-16 '
                    >
                      <div>Fishing Included:</div>
                      <div>{Package?.supports_fishing ? 'Yes' : 'No'}</div>
                    </Col>

                    <Col className='details' span={12}>
                      No. Of Anglers:
                    </Col>
                    <Col span={12} className='summary-value details'>
                      {Package?.fishing_details?.number_of_anglers ?? 0}
                    </Col>

                    <Col className='details' span={12}>
                      No. Of Swims:
                    </Col>
                    <Col span={12} className='summary-value details'>
                      {Package?.fishing_details?.number_of_swims}
                    </Col>

                    <Col className='details' span={12}>
                      No. Of Fishing Days:
                    </Col>
                    <Col span={12} className='summary-value details'>
                      {Package?.fishing_details?.number_of_fishing_days}
                    </Col>

                    <Col className='details' span={12}>
                      Fishing Dates:
                    </Col>
                    <Col span={12} className='summary-value details'>
                      {formatDatesByMonth(
                        Package?.fishing_details?.fishing_dates
                      )}
                    </Col>
                  </Row>

                  {/* Taxi */}
                  <Row className='summary-section gSemiBold sb-blue-900 '>
                    <Col
                      span={24}
                      className='row-center justify-between mg-bottom-15 fs-16 '
                    >
                      <div>Taxi’s Included:</div>
                      <div>
                        {Package?.taxi_information?.taxi_booked ? 'Yes' : 'No'}
                      </div>
                    </Col>

                    <Col className='details' span={12}>
                      Pickup Date & Time:
                    </Col>
                    <Col span={12} className='summary-value details'>
                      {dayjs(
                        Package?.taxi_information?.pickup_date
                      ).isValid() &&
                        dayjs(Package?.taxi_information?.pickup_date)
                          .add(30, 'minute')
                          .startOf('hour')
                          .format('ha | DD/MM/YYYY')}
                    </Col>

                    <Col className='details' span={12}>
                      Pickup Location:
                    </Col>
                    <Col span={12} className='summary-value details'>
                      {Package?.taxi_information?.pickup_location}
                    </Col>

                    <Col className='details' span={12}>
                      Dropoff Date & Time:
                    </Col>
                    <Col span={12} className='summary-value details'>
                      {dayjs(
                        Package?.taxi_information?.dropoff_date
                      ).isValid() &&
                        dayjs(Package?.taxi_information?.dropoff_date)
                          .add(30, 'minute')
                          .startOf('hour')
                          .format('ha | DD/MM/YYYY')}
                    </Col>

                    <Col className='details' span={12}>
                      Dropoff Location:
                    </Col>
                    <Col span={12} className='summary-value details'>
                      {Package?.taxi_information?.dropoff_location}
                    </Col>
                  </Row>

                  {/* Add-ons */}
                  <Row className='summary-section gSemiBold sb-blue-900 '>
                    <Col
                      span={24}
                      className='row-center justify-between mg-bottom-15 fs-16 '
                    >
                      <div>Add-Ons:</div>
                      <div>{Package?.add_ons?.length ? 'Yes' : 'No'}</div>
                    </Col>
                    {Package?.add_ons?.map((item) => (
                      <Row className='w-full'>
                        <Col className='details' span={18}>
                          {item?.name}
                        </Col>
                        <Col span={6} className='summary-value details'>
                          x{item?.quantity}
                        </Col>
                      </Row>
                    ))}
                  </Row>
                </div>
                <div className='price-container'>
                  <div className='price-section sb-blue-900 justify-between'>
                    <div className='fs-20 gSemiBold'>Total Price:</div>
                    <div className='row-center'>
                      <div className='gSemiBold fs-14 mg-right-5'>(THB)</div>
                      <div
                        className='seagreen-bg-700 br5 white fs-18 gSemiBold pd-left-5 pd-right-5 txt-right'
                        style={{ minWidth: 100 }}
                      >
                        {Package?.total_price ?? 0}
                      </div>
                    </div>
                  </div>
                  <div className='price-section sb-blue-900'>
                    <div className='fs-20 gSemiBold center'>
                      Pay Today:
                      <div className='fs-12 gSemiBold'>(30% Deposit)</div>
                    </div>
                    <div className='row-center'>
                      <div className='gSemiBold fs-14 mg-right-5'>(THB)</div>
                      <div
                        className='seagreen-bg-500 br5 white txt-right fs-18 gSemiBold pd-left-5 pd-right-5'
                        style={{ minWidth: 100 }}
                      >
                        {Package?.deposit ?? 0}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
}

export default QuoteBooking;
